import { render, staticRenderFns } from "./UsersAndClientsSetting.vue?vue&type=template&id=33dd87d6&scoped=true"
import script from "./UsersAndClientsSetting.vue?vue&type=script&lang=js"
export * from "./UsersAndClientsSetting.vue?vue&type=script&lang=js"
import style0 from "./UsersAndClientsSetting.vue?vue&type=style&index=0&id=33dd87d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd87d6",
  null
  
)

export default component.exports